module.exports = __webpack_public_path__ + "static/media/standardBankEmblem.5ed72d1a.png";